<app-header
    [langSel]="selectedLanguage"
    (selectedLanguage)="switchedLanguage($event)"
></app-header>
<app-loader *ngIf="!questionairs?.length"></app-loader>
<div
    *ngIf="!submittedSuccessfully"
    class="tw-bg-gradient-to-b tw-from-[#FFFBF8] tw-to-[#F9F9F9]"
>
    <div>
        <img
            src="/assets/images/CGC%20Dev%20Program%20imSME%20Banner-07.webp"
            class="tw-h-[100%] tw-w-[100%] md:tw-m-0 sm:tw-m-auto"
            alt="Banner"
        />
    </div>
    <div
        class="tw-bg-gradient-to-b tw-from-[#FFFBF8] tw-to-[#F9F9F9] sm:tw-flex sm:tw-flex-col lg:tw-flex tw-flex-col tw-items-center sm:tw-items-center lg:tw-items-start lg:tw-flex-row tw-gap-[12vw] md:tw-gap-[5vw] 2xl:tw-gap-[2vw] tw-pt-[5rem] tw-pb-[2rem] sm:tw-pb-[2rem] lg:tw-pb-[3rem]"
    >
        <div
            class="tw-max-w-[100%] sm:tw-max-w-auto lg:tw-max-w-[100%] tw-flex tw-flex-col lg:tw-px-[4vw]"
        >
            <div
                class="tw-w-full tw-text-left lg:tw-text-left tw-text-[32px] lg:tw-text-[30px] tw-text-[#212121] tw-font-bold lg:tw-font-semibold tw-pl-[5vw] sm:tw-pl-[5vw] lg:tw-pl-[0vw] tw-pr-[5vw] sm:tw-pr-[5vw] lg:tw-pr-[0vw]"
            >
                {{ "COMMON.CGC_PROGRAMME" | translate }}
            </div>
            <div
                class="tw-pl-[5vw] sm:tw-pl-[5vw] lg:tw-pl-[0vw] tw-pr-[5vw] sm:tw-pr-[5vw] lg:tw-pr-[0vw] tw-pt-[4vw] sm:tw-pt-[4vw] lg:tw-pt-[2vw] tw-w-[100%] lg:tw-w-[100%] tw-text-left sm:tw-text-left lg:tw-text-left tw-text-[#000000] lg:tw-text-[30px] lg:tw-font-semibold"
            >
                {{ "CGC_DEV_PROG_PAGE.CGC_LND_FORM_SUBTITLE" | translate }} <span *ngIf="eventTitle?.length">:</span> {{ eventTitle }}
            </div>
        </div>
    </div>

    <!-- DESKTOP -->
    <div class="content tw-hidden lg:tw-flex sm:tw-hidden">
        <div (click)="closeDropdown()">
            <form
                [formGroup]="LNDForm"
                (ngSubmit)="onLNDFormSubmit($event, LNDForm.value)"
            >  
                <div class="tw-flex tw-flex-wrap tw-mb-[16px]">
                    <div class="tw-w-1/3">
                        <input-general
                            class="tw-block tw-mt-10 tw-w-auto"
                            [mandatoryField]="true"
                            [label]="'LND_FORM_QUESTION.NAME' | translate"
                            [controlName]="'name'"
                            [placeHolder]="'COMMON.TYPE_HERE' | translate"
                            [errors]="
                                getErrors('name', 'LND_FORM_QUESTION.NAME' | translate)
                            "
                            (input)="alphabetOnly($event)"
                        ></input-general>
                    </div>
                </div>
                <div class="tw-flex tw-flex-wrap tw-gap-[16px] md:tw-gap-[32px] tw-mb-[16px]">
                    <div class="tw-w-1/3">
                        <input-general
                            class="tw-block tw-w-auto"
                            [mandatoryField]="true"
                            [label]="'LND_FORM_QUESTION.COMPANY_NAME' | translate"
                            [controlName]="'companyName'"
                            [placeHolder]="'COMMON.TYPE_HERE' | translate"
                            [errors]="
                                getErrors('companyName', 'LND_FORM_QUESTION.COMPANY_NAME' | translate)
                            "
                            (input)="alphaNumberOnly($event)"
                        ></input-general>
                    </div>
                    <div class="tw-w-1/3">
                        <input-general
                            class="tw-block tw-w-auto"
                            [mandatoryField]="true"
                            [label]="'LND_FORM_QUESTION.BIZ_REG_NO' | translate"
                            [controlName]="'bizRegNo'"
                            [placeHolder]="'COMMON.TYPE_HERE' | translate"
                            [errors]="
                                getErrors('bizRegNo', 'LND_FORM_QUESTION.BIZ_REG_NO' | translate)
                            "
                        ></input-general>
                    </div>
                </div>
                <div class="tw-flex tw-flex-wrap tw-gap-[16px] md:tw-gap-[32px] tw-mb-[16px]">
                    <div class="tw-w-1/3">
                        <select-general
                            class="tw-w-auto"
                            [options]="yearsInOperationOption"
                            [label]="'LND_FORM_QUESTION.YEARS_IN_OPERATION' | translate"
                            [placeHolder]="
                                'LND_FORM_QUESTION.YEARS_IN_OPERATION_PLACEHOLDER' | translate
                            "
                            [currentValue]="yearsInOperationValue"
                            (selectionChange)="handleYearsInOperationOptions($event)"
                            (dropdownToggle)="closeAllDropdowns(0)"
                            [mandatoryField]="true"
                            [controlName]="'yearsInOperation'"
                            [contentUnderline]="false"
                            [headerUnderline]="false"
                            [errors]="
                                getErrors(
                                    'yearsInOperation',
                                    'LND_FORM_QUESTION.YEARS_IN_OPERATION' | translate
                                )
                            "
                            [isDropdownOpen]="toggleDropDown[0]"
                        />
                    </div>
                    <div class="tw-w-1/3">
                        <select-general
                            class="tw-w-auto"
                            [options]="businessLocationOption"
                            [label]="'LND_FORM_QUESTION.BUSINESS_LOCATION' | translate"
                            [placeHolder]="
                                'LND_FORM_QUESTION.BUSINESS_LOCATION_PLACEHOLDER' | translate
                            "
                            [currentValue]="businessLocationValue"
                            (selectionChange)="handleBusinessLocationOptions($event)"
                            (dropdownToggle)="closeAllDropdowns(1)"
                            [mandatoryField]="true"
                            [controlName]="'businessLocation'"
                            [contentUnderline]="false"
                            [headerUnderline]="false"
                            [errors]="
                                getErrors(
                                    'businessLocation',
                                    'LND_FORM_QUESTION.BUSINESS_LOCATION' | translate
                                )
                            "
                            [isDropdownOpen]="toggleDropDown[1]"
                        />
                    </div>
                </div>
                <div class="tw-flex tw-flex-wrap tw-gap-[16px] md:tw-gap-[32px] tw-mb-[16px]">
                    <div class="tw-w-1/3">
                        <input-general
                            class="tw-block tw-w-auto"
                            [mandatoryField]="true"
                            [label]="'LND_FORM_QUESTION.EMAIL' | translate"
                            [controlName]="'email'"
                            [placeHolder]="'COMMON.TYPE_HERE' | translate"
                            [errors]="
                                getErrors('email', 'LND_FORM_QUESTION.EMAIL' | translate)
                            "
                        ></input-general>
                    </div>
                    <div class="tw-w-1/3">
                        <input-general
                            class="tw-w-auto"
                            [mandatoryField]="true"
                            [label]="'LND_FORM_QUESTION.MOBILE' | translate"
                            [controlName]="'mobileNo'"
                            [placeHolder]="'COMMON.TYPE_HERE' | translate"
                            [errors]="
                                getErrors('mobileNo', 'LND_FORM_QUESTION.MOBILE' | translate)
                            "
                            (input)="keyPressNumbers($event)"
                            (paste)="pasteNumberOnly($event)"
                            maxlength="17"
                        ></input-general>
                    </div>
                </div>
                <div class="tw-flex tw-flex-wrap tw-gap-[16px] md:tw-gap-[32px] tw-mb-[16px]">
                    <div class="tw-w-1/3">
                        <select-general
                            class="tw-w-auto"
                            [options]="businessSectorOption"
                            [label]="'LND_FORM_QUESTION.BUSINESS_SECTOR' | translate"
                            [placeHolder]="
                                'LND_FORM_QUESTION.BUSINESS_SECTOR_PLACEHOLDER' | translate
                            "
                            [currentValue]="businessSectorValue"
                            (selectionChange)="handleBusinessSectorOptions($event)"
                            (dropdownToggle)="closeAllDropdowns(2)"
                            [mandatoryField]="true"
                            [controlName]="'businessSector'"
                            [contentUnderline]="false"
                            [headerUnderline]="false"
                            [errors]="
                                getErrors(
                                    'businessSector',
                                    'LND_FORM_QUESTION.BUSINESS_SECTOR' | translate
                                )
                            "
                            [isDropdownOpen]="toggleDropDown[2]"
                        />
                    </div>
                    <div
                        *ngIf="eventType == NETWORKING_SESSION"
                        class="tw-w-1/3"
                    >
                        <input-general
                            class="tw-block tw-w-auto"
                            [mandatoryField]="true"
                            [label]="'LND_FORM_QUESTION.DESIGNATION' | translate"
                            [controlName]="'designation'"
                            [placeHolder]="'COMMON.TYPE_HERE' | translate"
                            [errors]="
                                getErrors('designation', 'LND_FORM_QUESTION.DESIGNATION' | translate)
                            "
                            (input)="alphabetOnly($event)"
                        ></input-general>
                    </div>
                    <div
                        *ngIf="eventType == ACCESS_NEW_MARKETS"
                        class="tw-w-1/3"
                    >
                        <select-general
                            class="tw-w-auto"
                            [options]="interestedPlatformOption"
                            [label]="'LND_FORM_QUESTION.INTERESTED_TO_PARTICIPATE' | translate"
                            [placeHolder]="
                                'LND_FORM_QUESTION.INTERESTED_TO_PARTICIPATE_PLACEHOLDER' | translate
                            "
                            [currentValue]="interestedPlatformValue"
                            (selectionChange)="handleInterestedPlatformOptions($event)"
                            (dropdownToggle)="closeAllDropdowns(3)"
                            [mandatoryField]="true"
                            [controlName]="'platform'"
                            [contentUnderline]="false"
                            [headerUnderline]="false"
                            [errors]="
                                getErrors(
                                    'platform',
                                    'LND_FORM_QUESTION.INTERESTED_TO_PARTICIPATE' | translate
                                )
                            "
                            [isDropdownOpen]="toggleDropDown[3]"
                        />
                    </div>
                </div>

                <div
                    *ngIf="eventType === NETWORKING_SESSION"
                    class="tw-rounded-[16px] tw-flex tw-flex-wrap tw-gap-[16px] md:tw-gap-[32px] tw-mb-[16px]"
                >
                    <div class="tw-w-2/3 tw-bg-[#FFFFFF]">
                        <label class="tw-pt-[15px] tw-font-[500] tw-mb-[10px] tw-ml-[20px] tw-text-[12px] tw-text-[#8D8D8D]">
                            {{ "LND_FORM_QUESTION.SHARE" | translate }}
                        </label>
                        <textarea
                            class="tw-bg-[#FFFFFF] tw-max-[640px] tw-w-full tw-h-36 tw-bg-gray-200 tw-font-[500] tw-overflow-auto tw-rounded-3xl tw-pt-3.5 tw-pb-3.5 tw-px-6"
                            placeholder="{{ 'COMMON.TYPE_HERE' | translate }}"
                            formControlName="shareProducts"
                        ></textarea>
                    </div>
                </div>

                <div class="tw-flex tw-flex-wrap tw-mb-[16px] tw-mt-[50px]">
                    <div class="tw-w-full">
                        <label
                            class="tw-block tw-text-[21px] tw-leading-[32px] tw-text-black tw-font-[500] tw-mb-[20px]"
                        >
                            {{ "LND_FORM_QUESTION.DISCLAIMER" | translate }}
                        </label>
                    </div>
                    <div class="tw-bg-[#EFEFEF] tw-rounded-[24px] tw-font-[500] tw-leading-[24px] tw-text-[16px] tw-text-[#6F6F6F] tw-py-[20px] tw-px-[40px]">
                        <span>{{ "LND_FORM_QUESTION.DISCLAIMER_DESC" | translate}}</span>
                    </div>
                </div>

                <div class="tw-flex tw-flex-wrap tw-mb-[16px] tw-mt-[50px]">
                    <div class="tw-w-full">
                        <label
                            class="tw-block tw-text-[21px] tw-leading-[32px] tw-text-black tw-font-[500] tw-mb-[20px]"
                        >
                            {{ "LND_FORM_QUESTION.CONSENT" | translate }}
                        </label>
                    </div>
                    <div class="tw-bg-[#EFEFEF] tw-rounded-[24px] tw-font-[500] tw-leading-[24px] tw-text-[16px] tw-text-[#6F6F6F] tw-py-[20px] tw-px-[40px]">
                        <div>{{ "LND_FORM_QUESTION.CONSENT_1" | translate }}</div>
                        <div class="tw-mt-[20px]">{{ "LND_FORM_QUESTION.CONSENT_2" | translate}}</div>
                        <div class="tw-mt-[20px]">{{ "LND_FORM_QUESTION.CONSENT_3" | translate}}</div>
                        <div class="tw-mt-[20px]">{{ "LND_FORM_QUESTION.CONSENT_4" | translate}}
                            <span class="tw-text-blue-600 dark:tw-text-blue-500 hover:tw-underline"><a href="https://www.cgc.com.my/privacy-security/">https://www.cgc.com.my/privacy-security/</a></span>.
                        </div>
                    </div>
                </div>

                <div class="tw-mt-[50px]">
                    <button
                        class="mat-elevation-z8 tw-bg-gradient-to-r tw-from-orange-400 tw-to-amber-300 tw-text-white md:tw-max-w-[185px] tw-w-full tw-text-center tw-rounded-[32px] tw-py-[22px]"
                        type="submit"
                        name="SUBMIT"
                    >
                        {{ "SUBMIT" | translate }}
                    </button>
                </div>
            </form>
        </div>
    </div>

    <!-- MOBILE -->
    <div
        class="tw-flex sm:tw-flex lg:tw-hidden tw-container tw-m-auto tw-grid tw-grid-cols-1 tw-gap-5 lg:!tw-hidden tw-justify-start [&>*]:tw-py-[4vw] md:[&>*]:tw-p-[2vw]"
    >
        <div (click)="closeDropdown()">
            <form
                [formGroup]="LNDForm"
                (ngSubmit)="onLNDFormSubmit($event, LNDForm.value)"
            >  
                <div class="tw-flex tw-flex-wrap tw-mb-[16px]">
                    <div class="tw-w-full">
                        <input-general
                            class="tw-block tw-mt-10 tw-w-auto"
                            [mandatoryField]="true"
                            [label]="'LND_FORM_QUESTION.NAME' | translate"
                            [controlName]="'name'"
                            [placeHolder]="'COMMON.TYPE_HERE' | translate"
                            [errors]="
                                getErrors('name', 'LND_FORM_QUESTION.NAME' | translate)
                            "
                            (input)="alphabetOnly($event)"
                        ></input-general>
                    </div>
                </div>
                <div class="tw-flex tw-flex-wrap tw-gap-[16px] md:tw-gap-[32px] tw-mb-[16px]">
                    <div class="tw-w-full">
                        <input-general
                            class="tw-block tw-w-auto"
                            [mandatoryField]="true"
                            [label]="'LND_FORM_QUESTION.COMPANY_NAME' | translate"
                            [controlName]="'companyName'"
                            [placeHolder]="'COMMON.TYPE_HERE' | translate"
                            [errors]="
                                getErrors('companyName', 'LND_FORM_QUESTION.COMPANY_NAME' | translate)
                            "
                            (input)="alphaNumberOnly($event)"
                        ></input-general>
                    </div>
                    <div class="tw-w-full">
                        <input-general
                            class="tw-block tw-w-auto"
                            [mandatoryField]="true"
                            [label]="'LND_FORM_QUESTION.BIZ_REG_NO' | translate"
                            [controlName]="'bizRegNo'"
                            [placeHolder]="'COMMON.TYPE_HERE' | translate"
                            [errors]="
                                getErrors('bizRegNo', 'LND_FORM_QUESTION.BIZ_REG_NO' | translate)
                            "
                        ></input-general>
                    </div>
                </div>
                <div class="tw-flex tw-flex-wrap tw-gap-[16px] md:tw-gap-[32px] tw-mb-[16px]">
                    <div class="tw-w-full">
                        <select-general
                            class="tw-w-auto"
                            [options]="yearsInOperationOption"
                            [label]="'LND_FORM_QUESTION.YEARS_IN_OPERATION' | translate"
                            [placeHolder]="
                                'LND_FORM_QUESTION.YEARS_IN_OPERATION_PLACEHOLDER' | translate
                            "
                            [currentValue]="yearsInOperationValue"
                            (selectionChange)="handleYearsInOperationOptions($event)"
                            (dropdownToggle)="closeAllDropdowns(0)"
                            [mandatoryField]="true"
                            [controlName]="'yearsInOperation'"
                            [contentUnderline]="false"
                            [headerUnderline]="false"
                            [errors]="
                                getErrors(
                                    'yearsInOperation',
                                    'LND_FORM_QUESTION.YEARS_IN_OPERATION' | translate
                                )
                            "
                            [isDropdownOpen]="toggleDropDown[0]"
                        />
                    </div>
                    <div class="tw-w-full">
                        <select-general
                            class="tw-w-auto"
                            [options]="businessLocationOption"
                            [label]="'LND_FORM_QUESTION.BUSINESS_LOCATION' | translate"
                            [placeHolder]="
                                'LND_FORM_QUESTION.BUSINESS_LOCATION_PLACEHOLDER' | translate
                            "
                            [currentValue]="businessLocationValue"
                            (selectionChange)="handleBusinessLocationOptions($event)"
                            (dropdownToggle)="closeAllDropdowns(1)"
                            [mandatoryField]="true"
                            [controlName]="'businessLocation'"
                            [contentUnderline]="false"
                            [headerUnderline]="false"
                            [errors]="
                                getErrors(
                                    'businessLocation',
                                    'LND_FORM_QUESTION.BUSINESS_LOCATION' | translate
                                )
                            "
                            [isDropdownOpen]="toggleDropDown[1]"
                        />
                    </div>
                </div>
                <div class="tw-flex tw-flex-wrap tw-gap-[16px] md:tw-gap-[32px] tw-mb-[16px]">
                    <div class="tw-w-full">
                        <input-general
                            class="tw-block tw-w-auto"
                            [mandatoryField]="true"
                            [label]="'LND_FORM_QUESTION.EMAIL' | translate"
                            [controlName]="'email'"
                            [placeHolder]="'COMMON.TYPE_HERE' | translate"
                            [errors]="
                                getErrors('email', 'LND_FORM_QUESTION.EMAIL' | translate)
                            "
                        ></input-general>
                    </div>
                    <div class="tw-w-full">
                        <input-general
                            class="tw-w-auto"
                            [mandatoryField]="true"
                            [label]="'LND_FORM_QUESTION.MOBILE' | translate"
                            [controlName]="'mobileNo'"
                            [placeHolder]="'COMMON.TYPE_HERE' | translate"
                            [errors]="
                                getErrors('mobileNo', 'LND_FORM_QUESTION.MOBILE' | translate)
                            "
                            (input)="keyPressNumbers($event)"
                            (paste)="pasteNumberOnly($event)"
                            maxlength="17"
                        ></input-general>
                    </div>
                </div>
                <div class="tw-flex tw-flex-wrap tw-gap-[16px] md:tw-gap-[32px] tw-mb-[16px]">
                    <div class="tw-w-full">
                        <select-general
                            class="tw-w-auto"
                            [options]="businessSectorOption"
                            [label]="'LND_FORM_QUESTION.BUSINESS_SECTOR' | translate"
                            [placeHolder]="
                                'LND_FORM_QUESTION.BUSINESS_SECTOR_PLACEHOLDER' | translate
                            "
                            [currentValue]="businessSectorValue"
                            (selectionChange)="handleBusinessSectorOptions($event)"
                            (dropdownToggle)="closeAllDropdowns(2)"
                            [mandatoryField]="true"
                            [controlName]="'businessSector'"
                            [contentUnderline]="false"
                            [headerUnderline]="false"
                            [errors]="
                                getErrors(
                                    'businessSector',
                                    'LND_FORM_QUESTION.BUSINESS_SECTOR' | translate
                                )
                            "
                            [isDropdownOpen]="toggleDropDown[2]"
                        />
                    </div>
                    <div
                        *ngIf="eventType == NETWORKING_SESSION"
                        class="tw-w-full"
                    >
                        <input-general
                            class="tw-block tw-w-auto"
                            [mandatoryField]="true"
                            [label]="'LND_FORM_QUESTION.DESIGNATION' | translate"
                            [controlName]="'designation'"
                            [placeHolder]="'COMMON.TYPE_HERE' | translate"
                            [errors]="
                                getErrors('designation', 'LND_FORM_QUESTION.DESIGNATION' | translate)
                            "
                            (input)="alphabetOnly($event)"
                        ></input-general>
                    </div>
                    <div
                        *ngIf="eventType == ACCESS_NEW_MARKETS"
                        class="tw-w-full"
                    >
                        <select-general
                            class="tw-w-auto"
                            [options]="interestedPlatformOption"
                            [label]="'LND_FORM_QUESTION.INTERESTED_TO_PARTICIPATE' | translate"
                            [placeHolder]="
                                'LND_FORM_QUESTION.INTERESTED_TO_PARTICIPATE_PLACEHOLDER' | translate
                            "
                            [currentValue]="interestedPlatformValue"
                            (selectionChange)="handleInterestedPlatformOptions($event)"
                            (dropdownToggle)="closeAllDropdowns(3)"
                            [mandatoryField]="true"
                            [controlName]="'platform'"
                            [contentUnderline]="false"
                            [headerUnderline]="false"
                            [errors]="
                                getErrors(
                                    'platform',
                                    'LND_FORM_QUESTION.INTERESTED_TO_PARTICIPATE' | translate
                                )
                            "
                            [isDropdownOpen]="toggleDropDown[3]"
                        />
                    </div>
                </div>

                <div
                    *ngIf="eventType == NETWORKING_SESSION"
                    class="tw-rounded-[16px] tw-flex tw-flex-wrap tw-gap-[16px] md:tw-gap-[32px] tw-mb-[16px]"
                >
                    <div class="tw-w-full tw-bg-[#FFFFFF]">
                        <label class="tw-pt-[15px] tw-font-[500] tw-mb-[10px] tw-ml-[20px] tw-text-[12px] tw-text-[#8D8D8D]">
                            {{ "LND_FORM_QUESTION.SHARE" | translate }}
                        </label>
                        <textarea
                            class="tw-bg-[#FFFFFF] tw-max-[640px] tw-w-full tw-h-36 tw-bg-gray-200 tw-font-[500] tw-overflow-auto tw-rounded-3xl tw-pt-3.5 tw-pb-3.5 tw-px-6"
                            placeholder="{{ 'COMMON.TYPE_HERE' | translate }}"
                            formControlName="shareProducts"
                        ></textarea>
                    </div>
                </div>

                <div class="tw-flex tw-flex-wrap tw-mb-[16px] tw-mt-[50px]">
                    <div class="tw-w-full">
                        <label
                            class="tw-block tw-text-[16px] tw-leading-[20px] tw-text-[#8D8D8D] tw-font-[600] tw-mb-[20px]"
                        >
                            {{ "LND_FORM_QUESTION.DISCLAIMER" | translate }}
                        </label>
                    </div>
                    <div class="tw-bg-[#EFEFEF] tw-rounded-[24px] tw-font-[500] tw-leading-[24px] tw-text-[16px] tw-text-[#8D8D8D] tw-py-[20px] tw-px-[40px]">
                        <span>{{ "LND_FORM_QUESTION.DISCLAIMER_DESC" | translate}}</span>
                    </div>
                </div>

                <div class="tw-flex tw-flex-wrap tw-mb-[16px] tw-mt-[50px]">
                    <div class="tw-w-full">
                        <label
                            class="tw-block tw-text-[16px] tw-leading-[20px] tw-text-[#8D8D8D] tw-font-[600] tw-mb-[20px]"
                        >
                            {{ "LND_FORM_QUESTION.CONSENT" | translate }}
                        </label>
                    </div>
                    <div class="tw-bg-[#EFEFEF] tw-rounded-[24px] tw-font-[500] tw-leading-[24px] tw-text-[16px] tw-text-[#8D8D8D] tw-py-[20px] tw-px-[40px]">
                        <div>{{ "LND_FORM_QUESTION.CONSENT_1" | translate }}</div>
                        <div class="tw-mt-[20px]">{{ "LND_FORM_QUESTION.CONSENT_2" | translate}}</div>
                        <div class="tw-mt-[20px]">{{ "LND_FORM_QUESTION.CONSENT_3" | translate}}</div>
                        <div class="tw-mt-[20px]">{{ "LND_FORM_QUESTION.CONSENT_4" | translate}}
                            <span class="tw-text-blue-600 dark:tw-text-blue-500 hover:tw-underline"><a href="https://www.cgc.com.my/privacy-security/">https://www.cgc.com.my/privacy-security/</a></span>.
                        </div>
                    </div>
                </div>

                <div class="tw-mt-[50px]">
                    <button
                        class="mat-elevation-z8 tw-bg-gradient-to-r tw-from-orange-400 tw-to-amber-300 tw-text-white md:tw-max-w-[304px] tw-w-full tw-text-center tw-rounded-[32px] tw-py-[22px]"
                        type="submit"
                        name="SUBMIT"
                    >
                        {{ "SUBMIT" | translate }}
                    </button>
                </div>
            </form>
        </div>
    </div>
</div>

<div
    *ngIf="submittedSuccessfully"
    (click)="closeMegaMenuCondition()"
    class="tw-hidden md:tw-hidden lg:tw-block"
>
    <div
        class="tw-flex tw-justify-center tw-gap-[6vw] md:tw-mt-[3rem] tw-px-[2rem] tw-py-[2rem]"
    >
        <div class="tw-mt-20">
            <div class="tw-flex tw-items-center tw-justify-center">
                <img
                    src="/assets/images/icons/Done.png"
                    alt="logo"
                    class="tw-h-auto tw-w-[64px] lg:tw-w-[64px]"
                />
            </div>
            <div class="tw-flex tw-items-center tw-justify-center">
                <div class="tw-text-[24px] tw-font-semibold tw-h-[32px] tw-mt-[40px]">
                    {{ "THANK_YOU" | translate }}
                </div>
            </div>
            <div class="tw-flex tw-items-center tw-justify-center">
                <div class="tw-text-[16px] tw-text-gray-400 tw-font-medium tw-h-[24px] tw-mt-[40px]">
                    {{ "REDIRECTION_MESSAGE" | translate }}
                </div>
            </div>
        </div>
    </div>
</div>
<div
    *ngIf="submittedSuccessfully"
    (click)="closeMegaMenuCondition()"
    class="tw-block sm:tw-block lg:tw-hidden"
>
    <div
        class="tw-flex tw-justify-center tw-gap-[6vw] md:tw-mt-[3rem] tw-px-[2rem] tw-py-[2rem]"
    >
        <div class="tw-mt-20">
            <div class="tw-flex tw-items-center tw-justify-center">
                <img
                    src="/assets/images/icons/Done.png"
                    alt="logo"
                    class="tw-h-auto tw-w-[64px] lg:tw-w-[64px]"
                />
            </div>
            <div class="tw-flex tw-items-center tw-justify-center">
                <div class="tw-text-[24px] tw-font-semibold tw-h-[32px] tw-mt-[40px]">
                    {{ "THANK_YOU" | translate }}
                </div>
            </div>
            <div class="tw-flex tw-items-center tw-justify-center tw-mb-[40px]">
                <div class="tw-text-[16px] tw-text-gray-400 tw-font-medium tw-h-[24px] tw-mt-[40px] tw-text-center">
                    {{ "REDIRECTION_MESSAGE" | translate }}
                </div>
            </div>
        </div>
    </div>
</div>
<app-footer></app-footer>